<template>
    <div class="footer">
        <div class="footer-container container text-left">
            <div class="row">
                <div class="col">
                    <a class="btn btn-outline-secondary" style="color: white" href="/">
                        <h2>nettipyora.fi</h2>
                    </a>
                    <div style="height: 1em"/>
                </div>
                <div class="col">
                    <button type="button" class="btn btn-primary" @click.stop="$router.push('/create')">
                        <div class="footer-button">{{langFooter.post[locale]}} <small><small>{{langFooter.forFree[locale]}}</small></small></div>
                        <small v-if="!$store.getters.isAuthenticated">{{langFooter.noLoginRequired[locale]}}</small> 
                    </button>
                    <div style="height: 1em"/>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="footer-title">{{langFooter.companyInfo[locale]}}</div>
                    <div class="footer-sub-title">{{langFooter.callUs[locale]}}</div>
                    <div><a href="tel:+358 456059077"  target="_blank">+358 456059077</a></div>
                    <div class="footer-sub-title">{{langFooter.email[locale]}}</div>
                    <div><a href="mailto:contact@nettipyora.fi" target="_blank">contact@nettipyora.fi</a></div>
                </div>
                <div class="col">
                    <a href="https://facebook.com" target="_blank">
                        <font-awesome-icon class="fa-icon" :icon="['fab', 'facebook-square']"/>
                    </a>
                    <div style="height: 1em"/>
                    <router-link  class="footer-title" to="/privacy-policy">{{langFooter.privacyPolicy[locale]}}</router-link>
                    <div style="height: 5px"/>
                    <router-link  class="footer-title" to="/advice">{{langFooter.advice[locale]}}</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import langFooter from '@/store/lang/footer';
import { mapState } from 'vuex';

export default {
    computed: mapState({
        locale: state => state.locale
    }),
    data() {
        return {
            langFooter
        }
    }    
}
</script>


<style scoped>
.footer > .container {
    padding-right: 15px;
    padding-left: 15px;
}
.footer {
    color: white;
    background: #00445E;
    padding: 30px;
    width: 100%;
}

.footer-button {
    font-weight: bold;
    font-size: 1.2em;
}

.footer-title {
    font-weight: bold;
    font-size: 1.1em;
    margin-bottom: 10px;
}

.footer-sub-title {
    font-size: 0.8em;
    font-weight: bold;
}

.fa-icon {
  font-size: 60px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
}

.fa-icon:hover {
    opacity: 0.7;
}

</style>

